import { MagicLinkLogin } from '../components/MagicLinkLogin';

export function PortalLoginPage() {
  return <MagicLinkLogin />;
}
